var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#455674"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0031 7.00098C11.6717 7.00098 11.4031 7.2515 11.4031 7.56062V16.4403C11.4031 16.7494 11.6717 16.9999 12.0031 16.9999C12.3345 16.9999 12.6031 16.7494 12.6031 16.4403V7.56062C12.6031 7.2515 12.3345 7.00098 12.0031 7.00098Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8057 10.6973L12.418 7.18297C12.1827 6.93901 11.8176 6.93901 11.5823 7.18297L8.19449 10.6973C7.94736 10.9537 7.93389 11.3841 8.16469 11.6587C8.28509 11.8022 8.44857 11.8747 8.61224 11.8747C8.76203 11.8747 8.91203 11.8142 9.02999 11.6918L12 8.61068L14.97 11.6918C15.2175 11.9482 15.6046 11.9332 15.8352 11.6587C16.0659 11.3841 16.0528 10.9537 15.8057 10.6973Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSmallIcon);
export default __webpack_public_path__ + "static/media/uploadSmallIcon.4ab0049f89c8927fdedd6ffe68ade056.svg";
export { ForwardRef as ReactComponent };